import { Injectable } from "@angular/core";
import { BaseRespone } from "src/app/models/common.response";
import { IMedicalRecord } from "./medical.type";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, take, tap } from "rxjs";
import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class MedicalRecordService {

    private _medicalRecord: BehaviorSubject<IMedicalRecord | null> = new BehaviorSubject<IMedicalRecord | null>(null);
    private _medicalRecords: BehaviorSubject<IMedicalRecord[]> = new BehaviorSubject<IMedicalRecord[]>([]);

   get medicalRecord$(): Observable<IMedicalRecord | null> {
        return this._medicalRecord.asObservable();
    }

    get medicalRecords$(): Observable<IMedicalRecord[]> {
        return this._medicalRecords.asObservable();
    }

    constructor(
        private _httpClient: HttpClient
    ) { }


    uploadMedicalRecord(record: FormData): Observable<BaseRespone<IMedicalRecord>> {
        return this._httpClient.post<BaseRespone<IMedicalRecord>>(`${environment.baseURl}/PatientDocument`, record)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newRecord) => {
                    // Return the new medical record
                    return newRecord;
                })
            )
    }

    getMedicalRecordByPatientID(id: number, opdId?: number) {
        let params = new HttpParams();
        if (opdId !== undefined) {
            params = params.set('opdId', opdId);
        }

        return this._httpClient.get<BaseRespone<IMedicalRecord[]>>(
            `${environment.baseURl}/PatientDocument/patientId/${id}`,
            { params }
        ).pipe(
            tap((response) => {
                this._medicalRecords.next(response.result ?? []);
            }),
            catchError((error) => {
                console.error('Error to Fetching data:', error);
                throw error;
            })
        );
    }

    hasMedicalRecords(patientId: number): Observable<boolean> {
        return this._httpClient
            .get<BaseRespone<IMedicalRecord[]>>(`${environment.baseURl}/PatientDocument/patientId/${patientId}`)
            .pipe(map(response => (response.result?.length ?? 0) > 0));
    }

    deleteMedicalRecord(id: number): Observable<BaseRespone<boolean>> {
        return this.medicalRecords$.pipe(
            take(1),
                switchMap(medicalRecords =>
                    this._httpClient.delete<BaseRespone<boolean>>(`${environment.baseURl}/PatientDocument/${id}`).pipe(
                        map((deletedResponse) => {
                            if (deletedResponse.result) {
                                const updatedMedicalRecords = medicalRecords.filter(item => item.id !== id);
                                this._medicalRecords.next(updatedMedicalRecords);
                            }
                            return deletedResponse;
                        })
                    )
                ), catchError((error) => {
                    return of(error.error);
            })
        );
    }

    downloadMedicalRecord(id: number): Observable<HttpResponse<Blob>> {
        return this._httpClient.get(
            `${environment.baseURl}/PatientDocument/download/${id}`,
            {
                responseType: 'blob',
                observe: 'response'
            }) as Observable<HttpResponse<Blob>>;
    }



}
